<template>
    <div class="modal-dialog">
        <slot></slot>        
    </div>
</template>

